import { initializeApp } from 'firebase/app'
import { connectAuthEmulator, getAuth } from 'firebase/auth'
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check'
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions'

const firebaseConfig = {
  apiKey: 'AIzaSyANyUeC8xCB_EUpJdo8PPzUoRAvRIJzBXY',
  authDomain: 'omikina-ai-infrastructure.firebaseapp.com',
  projectId: 'omikina-ai-infrastructure',
  storageBucket: 'omikina-ai-infrastructure.firebasestorage.app',
  messagingSenderId: '1057994891088',
  appId: '1:1057994891088:web:8c1fa0d0a73f8a77201655',
}

export const firebaseApp = initializeApp(firebaseConfig)
export const firebaseAuth = getAuth(firebaseApp)
export const firebaseFunctions = getFunctions(firebaseApp, 'us-central1')

if (import.meta.env.VITE_USE_FIREBASE_EMULATORS === 'true') {
  connectAuthEmulator(firebaseAuth, 'http://127.0.0.1:9099', { disableWarnings: true })
  connectFunctionsEmulator(firebaseFunctions, '127.0.0.1', 5001)
}

const appCheckSiteKey = import.meta.env.VITE_FIREBASE_APPCHECK_SITE_KEY
if (appCheckSiteKey && typeof window !== 'undefined') {
  initializeAppCheck(firebaseApp, { provider: new ReCaptchaV3Provider(appCheckSiteKey), isTokenAutoRefreshEnabled: true })
}
